





















































































































































































































import { createOperationLogApi } from "@/api/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { eduListApi, eduDataInter } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() data!: any;
  @Prop() search!: any;
  tableData: any = [];
  currentSortOption: any = {
    order: "descending",
    prop: "lesson_date",
  };
  paginationData: any = [];
  dataCache: any = {};
  s_t: string = "";
  e_t: string = "";
  exporting: boolean = false;
  @Watch("data", { immediate: false, deep: true })
  onChangeValue(v: any) {
    this.getList();
  }
  @Watch("search", { immediate: false, deep: true })
  onChangeSearch(v: any) {
    this.getList();
  }
  created() {
    if (this.data.length > 0) {
      this.getList();
    }
  }
  getList() {
    const params: eduDataInter = {
      start_date: this.data[0],
      end_date: this.data[1],
    };
    if (this.search.eduStaff_id && this.search.region === 1) {
      params.edu_teacher_id = this.search.eduStaff_id;
    }
    if (this.search.teachStaff_id && this.search.region === 2) {
      params.teacher_id = this.search.teachStaff_id;
    }
    if (this.search.class_id && this.search.region === 3) {
      params.class_id = this.search.class_id;
    }
    if (this.search.subject_id && this.search.region === 4) {
      params.subject_id = this.search.subject_id;
    }
    eduListApi(params).then((res: any) => {
      if (res.error_code === 0) {
        this.dataCache = res.data ? res.data : [];
        this.solveShowData();
        if (this.search.day_week_month === 1) {
          this.handleSortChange({
            order: "descending",
            prop: "lesson_date",
          });
        } else {
          this.handleSortChange({
            order: "descending",
            prop: "start",
          });
        }
      }
    });
  }
  newDate(time: any) {
    if (typeof time === "string") {
      return new Date(time.replace(/-/g, "/"));
    } else {
      return new Date(time);
    }
  }
  // 数据处理
  solveShowData() {
    const dates = this.getDateArray(this.data[0], this.data[1]);
    const data = this.dataCache;
    let resX: any = [];
    const resList: any = [];
    const timeType = this.search.day_week_month;
    // 处理日
    if (timeType === 1) {
      resX = dates;
      resX.map((date: string, index: number) => {
        const week = ["日", "一", "二", "三", "四", "五", "六"][
          this.newDate(date).getDay()
        ];
        if (data[date]) {
          data[date].week = week;
          data[date].lesson_date = date;
          resList.push(data[date]);
        } else {
          resList.push({
            week: week,
            lesson_date: date,
            attendance_rate: "0.00",
            consume_amount: "0.00",
            on_going_num: 0,
            otm_consume_amount: "0.00",
            otm_real_consume_num: "0.00",
            otm_sufficient_class_data: {
              consume_student_num: 0,
              preset_student_num: 0,
            },
            otm_sufficient_class_rate: "0.00",
            oto_consume_amount: "0.00",
            oto_real_consume_num: "0.00",
            real_consume_num: "0.00",
            roll_call_absent_student_num: 0,
            roll_call_attend_student_num: 0,
            roll_call_experience_student_num: 0,
            roll_call_lesson_num: 0,
            roll_call_make_up_student_num: 0,
            roll_call_temporary_student_num: 0,
            roll_call_normal_student_num: 0,
            roll_call_should_attend_student_num: 0,
          });
        }
      });
    }
    // 处理周
    if (timeType === 2) {
      let i = 0;
      dates.map((date: any, index: number) => {
        const week = ["日", "一", "二", "三", "四", "五", "六"][
          this.newDate(date).getDay()
        ];
        if (index === 0) {
          // 第一天
          resX[0] = date;
          if (data[date]) {
            resList[0] = {
              start: date,
              end: "",
              ...data[date],
            };
          } else {
            resList[0] = {
              start: date,
              end: "",
              lesson_date: date,
              attendance_rate: "0.00",
              consume_amount: "0.00",
              on_going_num: 0,
              otm_consume_amount: "0.00",
              otm_real_consume_num: "0.00",
              otm_sufficient_class_data: {
                consume_student_num: 0,
                preset_student_num: 0,
              },
              otm_sufficient_class_rate: "0.00",
              oto_consume_amount: "0.00",
              oto_real_consume_num: "0.00",
              real_consume_num: "0.00",
              roll_call_absent_student_num: 0,
              roll_call_attend_student_num: 0,
              roll_call_experience_student_num: 0,
              roll_call_lesson_num: 0,
              roll_call_make_up_student_num: 0,
              roll_call_temporary_student_num: 0,
              roll_call_normal_student_num: 0,
              roll_call_should_attend_student_num: 0,
            };
          }
        } else {
          if (week === "日") {
            // 周日，开始
            i = i + 1;
            resX[i] = date;
            if (data[date]) {
              resList[i] = {
                start: date,
                end: "",
                ...data[date],
              };
            } else {
              resList[i] = {
                start: date,
                end: "",
                lesson_date: date,
                attendance_rate: "0.00",
                consume_amount: "0.00",
                on_going_num: 0,
                otm_consume_amount: "0.00",
                otm_real_consume_num: "0.00",
                otm_sufficient_class_data: {
                  consume_student_num: 0,
                  preset_student_num: 0,
                },
                otm_sufficient_class_rate: "0.00",
                oto_consume_amount: "0.00",
                oto_real_consume_num: "0.00",
                real_consume_num: "0.00",
                roll_call_absent_student_num: 0,
                roll_call_attend_student_num: 0,
                roll_call_experience_student_num: 0,
                roll_call_lesson_num: 0,
                roll_call_make_up_student_num: 0,
                roll_call_temporary_student_num: 0,
                roll_call_normal_student_num: 0,
                roll_call_should_attend_student_num: 0,
              };
            }
          } else {
            if (data[date]) {
              resList[i].attendance_rate =
                Number(resList[i].attendance_rate) +
                Number(data[date].attendance_rate);
              resList[i].consume_amount =
                Number(resList[i].consume_amount) +
                Number(data[date].consume_amount);
              resList[i].otm_real_consume_num =
                Number(resList[i].otm_real_consume_num) +
                Number(data[date].otm_real_consume_num);
              resList[i].otm_sufficient_class_data.consume_student_num =
                Number(
                  resList[i].otm_sufficient_class_data.consume_student_num
                ) +
                Number(
                  data[date].otm_sufficient_class_data.consume_student_num
                );
              resList[i].otm_sufficient_class_data.preset_student_num =
                Number(
                  resList[i].otm_sufficient_class_data.preset_student_num
                ) +
                Number(data[date].otm_sufficient_class_data.preset_student_num);
              resList[i].otm_sufficient_class_rate =
                Number(resList[i].otm_sufficient_class_rate) +
                Number(data[date].otm_sufficient_class_rate);
              resList[i].oto_consume_amount =
                Number(resList[i].oto_consume_amount) +
                Number(data[date].oto_consume_amount);
              resList[i].oto_real_consume_num =
                Number(resList[i].oto_real_consume_num) +
                Number(data[date].oto_real_consume_num);
              resList[i].real_consume_num =
                Number(resList[i].real_consume_num) +
                Number(data[date].real_consume_num);
              resList[i].roll_call_absent_student_num =
                Number(resList[i].roll_call_absent_student_num) +
                Number(data[date].roll_call_absent_student_num);
              resList[i].roll_call_attend_student_num =
                Number(resList[i].roll_call_attend_student_num) +
                Number(data[date].roll_call_attend_student_num);
              resList[i].roll_call_experience_student_num =
                Number(resList[i].roll_call_experience_student_num) +
                Number(data[date].roll_call_experience_student_num);
              resList[i].roll_call_lesson_num =
                Number(resList[i].roll_call_lesson_num) +
                Number(data[date].roll_call_lesson_num);
              resList[i].roll_call_make_up_student_num =
                Number(resList[i].roll_call_make_up_student_num) +
                Number(data[date].roll_call_make_up_student_num);
              resList[i].roll_call_temporary_student_num =
                Number(resList[i].roll_call_temporary_student_num) +
                Number(data[date].roll_call_temporary_student_num);
              resList[i].roll_call_normal_student_num =
                Number(resList[i].roll_call_normal_student_num) +
                Number(data[date].roll_call_normal_student_num);
              resList[i].roll_call_should_attend_student_num =
                Number(resList[i].roll_call_should_attend_student_num) +
                Number(data[date].roll_call_should_attend_student_num);
            }
            if (week === "六" || index === dates.length - 1) {
              // 周六或最后一天
              resX[i] = resX[i] + " ~ " + date;
              resList[i].end = date;
              resList[i].on_going_num = data[date].on_going_num; // 在读学员显示当前时间范围最后一天的数据
              resList[i].lesson_date = resList[i].lesson_date + "~" + date;
              if (resList[i].attendance_rate !== "0.00") {
                resList[i].attendance_rate = Number(
                  resList[i].attendance_rate
                ).toFixed(2);
              }
              if (resList[i].consume_amount !== "0.00") {
                resList[i].consume_amount = Number(
                  resList[i].consume_amount
                ).toFixed(2);
              }
              if (resList[i].otm_sufficient_class_rate !== "0.00") {
                resList[i].otm_sufficient_class_rate = Number(
                  resList[i].otm_sufficient_class_rate
                ).toFixed(2);
              }
            }
          }
        }
      });
    }
    // 处理月
    if (timeType === 3) {
      let i = 0;
      dates.map((date: any, index: number) => {
        if (index === 0) {
          // 第一天
          resX[0] = date;
          if (data[date]) {
            resList[0] = {
              start: date,
              end: "",
              ...data[date],
            };
          } else {
            resList[0] = {
              start: date,
              end: "",
              lesson_date: date,
              attendance_rate: "0.00",
              consume_amount: "0.00",
              on_going_num: 0,
              otm_consume_amount: "0.00",
              otm_real_consume_num: "0.00",
              otm_sufficient_class_data: {
                consume_student_num: 0,
                preset_student_num: 0,
              },
              otm_sufficient_class_rate: "0.00",
              oto_consume_amount: "0.00",
              oto_real_consume_num: "0.00",
              real_consume_num: "0.00",
              roll_call_absent_student_num: 0,
              roll_call_attend_student_num: 0,
              roll_call_experience_student_num: 0,
              roll_call_lesson_num: 0,
              roll_call_make_up_student_num: 0,
              roll_call_temporary_student_num: 0,
              roll_call_normal_student_num: 0,
              roll_call_should_attend_student_num: 0,
            };
          }
        } else {
          if (date.slice(8) === "01") {
            // 一号，开始
            i = i + 1;
            resX[i] = date;
            if (data[date]) {
              resList[i] = {
                start: date,
                end: "",
                ...data[date],
              };
            } else {
              resList[i] = {
                start: date,
                end: "",
                lesson_date: date,
                attendance_rate: "0.00",
                consume_amount: "0.00",
                on_going_num: 0,
                otm_consume_amount: "0.00",
                otm_real_consume_num: "0.00",
                otm_sufficient_class_data: {
                  consume_student_num: 0,
                  preset_student_num: 0,
                },
                otm_sufficient_class_rate: "0.00",
                oto_consume_amount: "0.00",
                oto_real_consume_num: "0.00",
                real_consume_num: "0.00",
                roll_call_absent_student_num: 0,
                roll_call_attend_student_num: 0,
                roll_call_experience_student_num: 0,
                roll_call_lesson_num: 0,
                roll_call_make_up_student_num: 0,
                roll_call_temporary_student_num: 0,
                roll_call_normal_student_num: 0,
                roll_call_should_attend_student_num: 0,
              };
            }
          } else {
            if (data[date]) {
              resList[i].attendance_rate =
                Number(resList[i].attendance_rate) +
                Number(data[date].attendance_rate);
              resList[i].consume_amount =
                Number(resList[i].consume_amount) +
                Number(data[date].consume_amount);
              resList[i].otm_real_consume_num =
                Number(resList[i].otm_real_consume_num) +
                Number(data[date].otm_real_consume_num);
              resList[i].otm_sufficient_class_data.consume_student_num =
                Number(
                  resList[i].otm_sufficient_class_data.consume_student_num
                ) +
                Number(
                  data[date].otm_sufficient_class_data.consume_student_num
                );
              resList[i].otm_sufficient_class_data.preset_student_num =
                Number(
                  resList[i].otm_sufficient_class_data.preset_student_num
                ) +
                Number(data[date].otm_sufficient_class_data.preset_student_num);
              resList[i].otm_sufficient_class_rate =
                Number(resList[i].otm_sufficient_class_rate) +
                Number(data[date].otm_sufficient_class_rate);
              resList[i].oto_consume_amount =
                Number(resList[i].oto_consume_amount) +
                Number(data[date].oto_consume_amount);
              resList[i].oto_real_consume_num =
                Number(resList[i].oto_real_consume_num) +
                Number(data[date].oto_real_consume_num);
              resList[i].real_consume_num =
                Number(resList[i].real_consume_num) +
                Number(data[date].real_consume_num);
              resList[i].roll_call_absent_student_num =
                Number(resList[i].roll_call_absent_student_num) +
                Number(data[date].roll_call_absent_student_num);
              resList[i].roll_call_attend_student_num =
                Number(resList[i].roll_call_attend_student_num) +
                Number(data[date].roll_call_attend_student_num);
              resList[i].roll_call_experience_student_num =
                Number(resList[i].roll_call_experience_student_num) +
                Number(data[date].roll_call_experience_student_num);
              resList[i].roll_call_lesson_num =
                Number(resList[i].roll_call_lesson_num) +
                Number(data[date].roll_call_lesson_num);
              resList[i].roll_call_make_up_student_num =
                Number(resList[i].roll_call_make_up_student_num) +
                Number(data[date].roll_call_make_up_student_num);
              resList[i].roll_call_temporary_student_num =
                Number(resList[i].roll_call_temporary_student_num) +
                Number(data[date].roll_call_temporary_student_num);
              resList[i].roll_call_normal_student_num =
                Number(resList[i].roll_call_normal_student_num) +
                Number(data[date].roll_call_normal_student_num);
              resList[i].roll_call_should_attend_student_num =
                Number(resList[i].roll_call_should_attend_student_num) +
                Number(data[date].roll_call_should_attend_student_num);
            }
            if (
              (dates[index + 1] && dates[index + 1].slice(8) === "01") ||
              index === dates.length - 1
            ) {
              // 月末或最后一天
              resX[i] = resX[i] + " ~ " + date;
              resList[i].end = date;
              resList[i].on_going_num = data[date].on_going_num; // 在读学员显示当前时间范围最后一天的数据
              resList[i].lesson_date = resList[i].lesson_date + "~" + date;
              if (resList[i].attendance_rate !== "0.00") {
                resList[i].attendance_rate = Number(
                  resList[i].attendance_rate
                ).toFixed(2);
              }
              if (resList[i].consume_amount !== "0.00") {
                resList[i].consume_amount = Number(
                  resList[i].consume_amount
                ).toFixed(2);
              }
              if (resList[i].otm_sufficient_class_rate !== "0.00") {
                resList[i].otm_sufficient_class_rate = Number(
                  resList[i].otm_sufficient_class_rate
                ).toFixed(2);
              }
            }
          }
        }
      });
    }
    // 结算出勤率
    resList.map((item: any) => {
      item.attendance_rate = (
        (Number(item.roll_call_attend_student_num) * 100) /
        (Number(item.roll_call_should_attend_student_num) || 1)
      ).toFixed(2);
    });
    // 结算1vN满班率
    resList.map((item: any) => {
      item.otm_sufficient_class_rate = (
        Number(item.otm_sufficient_class_data.preset_student_num) > 0
          ? (Number(item.otm_sufficient_class_data.consume_student_num) /
              Number(item.otm_sufficient_class_data.preset_student_num)) *
            100
          : 0
      ).toFixed(2);
    });
    resList.map((it: any) => {
      it.attendance_rate = roundNumbers(it.attendance_rate) + "%";
      it.consume_amount = roundNumbers(it.consume_amount);
      it.otm_consume_amount = roundNumbers(it.otm_consume_amount);
      it.otm_real_consume_num = roundNumbers(it.otm_real_consume_num);
      it.otm_sufficient_class_rate =
        roundNumbers(it.otm_sufficient_class_rate) + "%";
      it.oto_consume_amount = roundNumbers(it.oto_consume_amount);
      it.oto_real_consume_num = roundNumbers(it.oto_real_consume_num);
      it.real_consume_num = roundNumbers(it.real_consume_num);
    }),
      (this.tableData = resList);
    this.paginationData = resList;
  }
  getDateArray(start: string, end: string) {
    let startDate: number = 0;
    const endDate: number = this.newDate(end).getTime();
    if (this.search.range === "today" || this.search.range === "yesterday") {
      // 时间段选今天或昨天时要补足前30天
      startDate = this.newDate(start).getTime() - 30 * 24 * 60 * 60 * 1000;
    } else {
      startDate = this.newDate(start).getTime();
    }
    const range = (endDate - startDate) / (24 * 60 * 60 * 1000);
    const res: any[] = [];
    for (let i = 0; i <= range; i++) {
      const cur = this.newDate(startDate + i * 24 * 60 * 60 * 1000);
      const y = cur.getFullYear();
      const m = cur.getMonth() + 1;
      const d = cur.getDate();
      res.push(`${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`);
    }
    return res;
  }
  handleSortChange(val: any) {
    this.currentSortOption = {
      order: val.order,
      prop: val.prop,
    };
    const newArr = JSON.parse(JSON.stringify(this.tableData));
    newArr.map((it: any) => {
      if (it.lesson_date) {
        it.lesson_date = new Date(it.lesson_date).getTime();
      }
      if (it.start) {
        it.start = new Date(it.start).getTime();
      }
    });
    this.tableData = this.sortList(newArr);
  }
  sortList(val: any[]) {
    const copy = [...val];
    copy.sort((a: any, b: any) => {
      return (
        Number(b[this.currentSortOption.prop]) -
        Number(a[this.currentSortOption.prop])
      );
    });
    copy.map((it: any, ind: any) => {
      it.ind = ind + 1;
      if (it.lesson_date) {
        it.lesson_date = String(dateFormat("YYYY-mm-dd", it.lesson_date));
      }
      if (it.start) {
        it.start = String(dateFormat("YYYY-mm-dd", it.start));
      }
    });
    if (this.currentSortOption.order === "ascending") {
      copy.reverse();
    }
    return copy;
  }
  // 导出
  handleExport() {
    if (this.exporting) {
      return false;
    }
    createOperationLogApi({
      code: 10503,
      detail: "导出教务数据明细",
    });
    const dateArr = JSON.parse(JSON.stringify(this.tableData));
    dateArr.map((it: any) => {
      if (it.start && it.end) {
        it.lesson_date = `${it.start} ~ ${it.end}`;
      }
    });
    this.exporting = true;
    const date: any = new Date().getTime();
    const dateTime = dateFormat("YYYYmmddHHMMSS", date);
    const endThree = String(date).slice(-3, date.length);
    try {
      let result = "";
      if (!this.search.showRegionTab) {
        result = json2csv.parse(
          [
            {
              lesson_date: "查询时间",
              on_going_num: "在读学员",
              attendance_rate: "出勤率 (%)",
              otm_sufficient_class_rate: "1vN满班率 (%)",
              roll_call_attend_student_num: "点名实到学员",
              // roll_call_absent_student_num: "点名未到学员",
              // roll_call_normal_student_num: "点名正课学员",
              roll_call_make_up_student_num: "点名补课学员",
              roll_call_temporary_student_num: "点名临时学员",
              // roll_call_experience_student_num: "点名体验学员",
              roll_call_should_attend_student_num: "点名应到学员",
              roll_call_lesson_num: "点名课次",
              real_consume_num: "耗课数",
              consume_amount: " 课消金额 (元)",
            },
            ...dateArr,
          ],
          {
            fields: [
              "lesson_date",
              "on_going_num",
              "attendance_rate",
              "otm_sufficient_class_rate",
              "roll_call_attend_student_num",
              "roll_call_make_up_student_num",
              "roll_call_temporary_student_num",
              "roll_call_should_attend_student_num",
              "roll_call_lesson_num",
              "real_consume_num",
              "consume_amount",
            ],
            header: false,
          }
        );
      } else {
        // 高级筛选导出
        result = json2csv.parse(
          [
            {
              lesson_date: "查询时间",
              attendance_rate: "出勤率 (%)",
              roll_call_should_attend_student_num: "点名应到学员",
              // roll_call_absent_student_num: "点名未到学员",
              // roll_call_normal_student_num: "点名正课学员",
              roll_call_make_up_student_num: "点名补课学员",
              roll_call_temporary_student_num: "点名临时学员",
              // roll_call_experience_student_num: "点名体验学员",
              roll_call_attend_student_num: "点名实到学员",
              roll_call_lesson_num: "点名课次",
              real_consume_num: "耗课数",
              consume_amount: " 课消金额 (元)",
            },
            ...dateArr,
          ],
          {
            fields: [
              "lesson_date",
              "attendance_rate",
              "roll_call_should_attend_student_num",
              "roll_call_make_up_student_num",
              "roll_call_temporary_student_num",
              "roll_call_attend_student_num",
              "roll_call_lesson_num",
              "real_consume_num",
              "consume_amount",
            ],
            header: false,
          }
        );
      }
      // 非IE浏览器
      const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      // 创建a标签下载
      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download = "教务数据" + dateTime + endThree;
      (".csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 5秒导出间隔
      setTimeout(() => {
        this.exporting = false;
      }, 5000);
    } catch (err: any) {
      this.$message({
        type: "error",
        message: err.toString(),
      });
    }
  }
}
